import './scss/index.scss';
import { dcFactory } from 'dc';
import ProductListComponent from './js/product-list.component.js';

dcFactory.register(ProductListComponent);
